<template class="item-kind-page">
  <section class="r-item-kind-page">
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="filteredItems"
      :item-class="classObj"
      item-key="uid"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 245"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Item Kind"
    >
      <template #search-prepend>
        <v-autocomplete
          v-model="selectedMaps"
          :items="availableMaps"
          label="Filter by Map"
          clearable
          hide-details
          dense
          multiple
          small-chips
          deletable-chips
          class="mr-2"
          style="max-width: 250px; min-width: 200px;"
          prepend-inner-icon="mdi-map-search"
          outlined
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index < 2"
              x-small
              close
              color="primary"
              @click:close="removeMap(item)"
            >
              {{ item }}
            </v-chip>
            <span
              v-if="index === 2"
              class="grey--text text-caption"
            >
              (+{{ selectedMaps.length - 2 }} more)
            </span>
          </template>
        </v-autocomplete>
      </template>

      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Item Kind
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
        <v-btn @click="exportData" class="ma-2" color="accent">
          EXPORT TO JSON
        </v-btn>
      </template>

      <template v-slot:item.group="{ item }">
        {{ item.group?.key || '' }}
      </template>

      <template v-slot:item.maps="{ item }">
        <div>
          <v-tooltip
            v-if="item.maps?.length > 3"
            bottom
            content-class="item-kind-page__ttip"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="item-kind-page__item-maps-coll"
                @click="copyMaps(item.maps)"
              >
                [Map Collection]
              </span>
            </template>
            <span>{{ item.maps.join(', ') }}</span>
          </v-tooltip>

          <span
            v-else
            class="item-kind-page__item-maps"
          >
            {{ item.maps?.join(', ') || '-' }}
          </span>
        </div>
      </template>

      <template v-slot:item.levels="{ item }">
        <div>
          <v-tooltip
            v-if="item.levels?.length > 3"
            bottom
            content-class="item-kind-page__ttip"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="item-kind-page__item-maps-coll"
                @click="copyMaps(item.levels)"
              >
                [Levels Collection]
              </span>
            </template>
            <span>{{ item.levels.join(', ') }}</span>
          </v-tooltip>

          <span
            v-else
            class="item-kind-page__item-maps"
          >
            {{ item.levels?.join(', ') || '-' }}
          </span>
        </div>
      </template>

      <template v-slot:item.posHero="{ item }">
        <span v-if="item.posHero && (item.posHero.x != null || item.posHero.y != null)">
          x: {{ item.posHero.x ?? 0 }}, y: {{ item.posHero.y ?? 0 }}
        </span>
      </template>

      <template v-slot:item.actions="{item}">
        <div style="white-space: nowrap">
          <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
            mdi-eye
          </v-icon>
          <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
            mdi-pencil
          </v-icon>
          <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
            mdi-pencil
          </v-icon>
          <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
            mdi-content-copy
          </v-icon>
          <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">
            mdi-briefcase-upload
          </v-icon>
          <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
            mdi-delete
          </v-icon>
        </div>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-item-kind-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {saveAs} from "file-saver";
import clsx from 'clsx';

import RItemKindDialog from "@/modules/redactor/views/item-kind/r-item-kind-dialog.vue";
import VueTypes from "vue-types";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-item-kind-page",
  components: {RDialogPreviewCollection, AcDataTable, RItemKindDialog},
  data: () => ({
    search: "",
    selectedMaps: [],
    headers: [
      {text: "Key", value: "key"},
      {text: "Code", value: "code"},
      {text: "Group", value: "group"},
      {text: "Priority", value: "priority"},
      {text: "Owners", value: "owners"},
      {text: "Maps", value: "maps"},
      {text: "Levels", value: "levels"},
      {text: "Cell Kinds", value: "cellKinds"},
      {text: "Has Merge Prompt", value: "hasMergePrompt"},
      {text: "Position Hero", value: "posHero"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],

    items: {
      type: VueTypes.arrayOf(ItemKindModel)
    },
    selected: [],
    bulkMode: false,
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    }
  }),

  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    },
    availableMaps() {
      // Collect all unique maps from all items
      const mapsSet = new Set();
      this.items.forEach(item => {
        if (item.maps && Array.isArray(item.maps)) {
          item.maps.forEach(map => mapsSet.add(map));
        }
      });
      return Array.from(mapsSet).sort((a, b) => {
        // Sort numerically if possible, otherwise alphabetically
        const numA = parseInt(a);
        const numB = parseInt(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return String(a).localeCompare(String(b));
      });
    },
    filteredItems() {
      // If no maps are selected, return all items
      if (!this.selectedMaps || this.selectedMaps.length === 0) {
        return this.items;
      }

      // Filter items that have at least one of the selected maps
      return this.items.filter(item => {
        if (!item.maps || !Array.isArray(item.maps)) {
          return false;
        }
        // Check if any selected map is in the item's maps
        return this.selectedMaps.some(selectedMap => item.maps.includes(selectedMap));
      });
    }
  },

  methods: {
    removeMap(mapToRemove) {
      const index = this.selectedMaps.indexOf(mapToRemove);
      if (index >= 0) {
        this.selectedMaps.splice(index, 1);
      }
    },

    classObj(item) {
      const highlightClass =
        item.global ? "cyan lighten-4" :
        item.export ? "green lighten-3" :
        item.changed ? "blue lighten-3" :
        !item.enabled ? "blue-grey lighten-3" :
        "";

      return clsx("item-kind-page__item", highlightClass);
    },

    copyMaps(maps) {
      if (!maps || maps.length <= 3) return;

      const text = maps.join(', ');

      navigator.clipboard.writeText(text)
        .then(() => {
          this.$alert?.("Copied to clipboard!") || console.log("Copied:", text);
        })
        .catch(err => {
          console.error("Clipboard copy failed:", err);
        });
    },

    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },

    row_copy(item) {
      this.$refs["dialog"].show(ViewRules.COPY, item.copy()).then(
        result => {
          if (this.item_duplicate(result)) {
            this.$alert("Duplicate item!");
          } else {
            RedactorUtils.pushItemKind(result).then(
              () => {
                this.$alert("Changes was published");
              });
          }
        }, () => {
        });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
        result => {
          if (this.item_duplicate(result)) {
            this.$alert("Duplicate item!");
          } else {
            RedactorUtils.pushItemKind(result).then(
              () => {
                this.$alert("Changes was published");
              });
          }
        }, () => {
        });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
        result => {
          RedactorUtils.pushItemKind(result).then(
            () => {
              this.$alert("Changes was published");
            });
        }, () => {
        });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeItemKind(item).then(
          () => {
            this.$alert("Changes was published");
          });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkItemKinds(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushItemKind(result);
    },

    exportData() {
      RedactorUtils.exportItemKinds()
        .then(data => {
          try {
            const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
            const formattedData = Object.entries(parsedData).map(([key, value]) => ({
              key: value.key || key,
              maps: value.maps || [],
              levels: Array.isArray(value.levels)
                ? (value.levels.length === 1
                  ? Array.from({ length: value.levels[0] + 1 }, (_, i) => i)
                  : value.levels)
                : []
            }));

            const blob = new Blob([JSON.stringify(formattedData, null, 2)], {
              type: "application/json"
            });

            saveAs(blob, "exported_item_kinds.json");
          } catch (error) {
            console.error("Error while processing JSON: ", error);
          }
        })
        .catch(error => console.error("Export error: ", error));
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, ItemKindModel, "item-kind")
          .then(() => this.$alert("Changes was published"));
    },
    item_duplicate(item) {
      return this.items.find(v => {
        if (v.item && item.item && v.item.equal(item.item)) {
          return v.uid !== item.uid;
        }

        return false;
      });
    },

    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    }
  },

  created() {
    this.items = RedactorUtils.getItemKinds();
  }
}

</script>

<style scoped lang="scss">
.item-kind-page {
  &__item {
    white-space: nowrap;

    &-maps {
      color: #424242;

      &-coll {
        color: #1976d2;
        text-decoration: underline dotted;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  &__ttip {
    background-color: #000;
    color: #fff;
  }
}

::v-deep .v-data-table thead th {
  white-space: nowrap;
}
</style>